import e from "./SourceTabs.module.js";
import { c as t } from "react/compiler-runtime";
import n from "classnames";
import r from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/SourceTabs/SourceTabs.tsx
var o = r.memo((r) => {
	let o = t(26), s, c, l, u, d, f;
	if (o[0] !== r) {
		let { options: e, selected: t, onSelectTab: n, className: i, hint: a, ...p } = r;
		u = e, d = t, s = i, c = a, l = p, f = (e) => {
			n(e.currentTarget.getAttribute("data-id") ?? "");
		}, o[0] = r, o[1] = s, o[2] = c, o[3] = l, o[4] = u, o[5] = d, o[6] = f;
	} else s = o[1], c = o[2], l = o[3], u = o[4], d = o[5], f = o[6];
	let p = f, m;
	o[7] === c ? m = o[8] : (m = c && /* @__PURE__ */ i("div", {
		className: e.hint,
		children: c
	}), o[7] = c, o[8] = m);
	let h;
	o[9] === s ? h = o[10] : (h = n(e.list, s), o[9] = s, o[10] = h);
	let g;
	if (o[11] !== p || o[12] !== u || o[13] !== d) {
		let t;
		o[15] !== p || o[16] !== d ? (t = (t) => /* @__PURE__ */ i("li", {
			className: n(e.option),
			title: t.tooltip,
			children: /* @__PURE__ */ i("button", {
				"data-id": t.id,
				className: n(e.button, { [e.selected]: d === t.id }),
				onClick: p,
				children: /* @__PURE__ */ i("span", {
					className: e.content,
					tabIndex: -1,
					children: t.title
				})
			}, t.id)
		}, t.id), o[15] = p, o[16] = d, o[17] = t) : t = o[17], g = u.map(t), o[11] = p, o[12] = u, o[13] = d, o[14] = g;
	} else g = o[14];
	let _;
	o[18] !== l || o[19] !== h || o[20] !== g ? (_ = /* @__PURE__ */ i("ul", {
		className: h,
		...l,
		children: g
	}), o[18] = l, o[19] = h, o[20] = g, o[21] = _) : _ = o[21];
	let v;
	o[22] === Symbol.for("react.memo_cache_sentinel") ? (v = /* @__PURE__ */ i("div", { className: e.tail }), o[22] = v) : v = o[22];
	let y;
	return o[23] !== m || o[24] !== _ ? (y = /* @__PURE__ */ a("div", {
		className: e.container,
		children: [
			m,
			_,
			v
		]
	}), o[23] = m, o[24] = _, o[25] = y) : y = o[25], y;
});
//#endregion
export { o as SourceTabs };
